import {
  BackendServerActionType,
  ButtonElementModel,
  ButtonPanelElementModel,
  CastUtility,
  ConfirmResult,
  DbCommonColumnName,
  DevelopEditViewScript,
  DevelopScriptServicePack,
  EditPanelElementModel,
  EditType,
  EditTypeUtility,
  InputPartsBaseModel,
  LinkElementModel,
  LoginUserUtility,
  MessageType,
  PanelModel,
  PanelType,
  ViewType,
  displayLock,
  displayUnLock,
} from '@ktvs8/gocoo-engine-front-end';
import { UserRole } from 'src/app/utility/application-user-utility';
import { EMailUtility } from 'src/app/utility/e-mail-utility';
export class MSupplierEdit implements DevelopEditViewScript {
  /**
   * スクリプト名
   */
  scriptName: string = 'MSupplierEdit';

  /**
   * メールアドレスが編集されているかを判定するために初期値を取得する
   */
  initEmailAddress: string = '';

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    const hiddenStatusName = () => {
      const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
      editPanel.inputPartsList.forEach((inputParts) => {
        if (inputParts.id === 'StatusName') {
          inputParts.isHidden = true;
        }
      });
    };

    const setupButtons = () => {
      const footerButtonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;
      footerButtonPanel.leftButtons.forEach((leftButton) => {
        if (leftButton.id === 'RegisterButton') {
          leftButton.isHidden = true;
        } else if (leftButton.id === 'ReCertificationButton') {
          leftButton.isHidden = false;
        } else {
          leftButton.isHidden = LoginUserUtility.getLoginUserRole() === UserRole.Legal;
        }
      });
    };

    if (EditTypeUtility.getEditTypeInUrl() === EditType.New) {
      hiddenStatusName();
    } else if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
      setupButtons();
    }
  }

  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * ボタン押下処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id === 'RegisterButton' || clickedButtonElement.id === 'ReCertificationButton') {
      this.registerRecord(panelModels, service);
    } else if (clickedButtonElement.id === 'DeleteButton') {
      this.deleteMSupplier(panelModels, service);
    }
  }

  /**
   * リンク押下処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 入力イベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 個別でバリデーションチェックを行う場合に使用
   * @param targetValidationPanel バリデーションチェックを必要とするpanel
   * @param actionType 実行する処理の種類
   * @param panelModels panelモデルのマップ(表示しているviewの全panelモデル)
   * @param service 使用できるサービス
   * @returns バリデーションチェック結果 true: 正常（異常無し） false: 異常あり
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
  /**
   * 編集画面で表示するデータを取得した際に実行される処理
   * @param editPanel 編集パネル
   * @param service サービスパック
   */
  fetchedRecord(editPanel: EditPanelElementModel, service: DevelopScriptServicePack): void {
    const setupClassStatus = () => {
      editPanel.inputPartsList
        .filter((inputParts) => inputParts.id === 'StatusName')
        .forEach((inputParts) => {
          if (inputParts.value === '認証済') {
            inputParts.classAtLabel.push('verified');
          } else if (inputParts.value === '認証待ち') {
            inputParts.classAtLabel.push('waiting');
          }
        });
    };
    this.initEmailAddress = editPanel.getIdAndValueAsObject()['EmailAddress'];
    setupClassStatus();
  }

  /**
   * ステータスと認証関連の値を設定する
   * @param record
   */
  setVerifyToRecord(record: any) {
    //一週間後の日付を文字列型で返す。
    const getNextWeekDate = (): string => {
      const today = new Date();
      const nextWeekDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
      return CastUtility.getDefaultFormatDay(nextWeekDate);
    };

    record['Status'] = 'Waiting';
    record['VerificationKey'] = EMailUtility.getVerificationKey();
    record['VerifyExpiration'] = getNextWeekDate();
    record['VerifyRequestUser'] = LoginUserUtility.getLoginUserMailAddress();
  }

  /**
   * 登録処理を行う。
   * @param panelModels
   * @param service
   */
  registerRecord(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    //入力チェックを行う。
    const checkInputParts = (editPanel: EditPanelElementModel) => {
      service.messageService.clearMessage();
      if (!editPanel.checkValidateAllInputParts()) {
        service.messageService.addMessage('入力エラーがあります。', MessageType.Error);
        return false;
      }
      return true;
    };

    const callBack = async (responseRecord: any) => {
      //認証用メール送信を行う。
      if (isCaseVerification) {
        displayLock('メール送信中');
        const response = await EMailUtility.sendVerifiedEmail(
          service,
          responseRecord.data[DbCommonColumnName.TICKET_KEY],
          request
        );
        displayUnLock();
        if (response.isCompleted) {
          service.dialogService.showOkOnlyConfirmDialog('認証メールを送信しました。');
        } else {
          service.messageService.addMessage('認証メールの送信に失敗しました。', MessageType.Error);
        }
      }

      //登録後読み取り専用画面に遷移する。
      displayUnLock();
      service.moveViewService.changeEditType(EditType.Readonly, {
        [DbCommonColumnName.TICKET_KEY]: responseRecord.data[DbCommonColumnName.TICKET_KEY],
      });
    };

    //確認ダイアログを開く
    const showConfirmDialog = () => {
      const message =
        EditTypeUtility.getEditTypeInUrl() === EditType.Readonly
          ? '発注先に\nメールアドレスの再認証を要求します。\nよろしいですか？'
          : 'データを登録します。よろしいですか？';
      return service.dialogService.showYesOrNoConfirmDialog(message).then((result) => {
        if (result !== ConfirmResult.Yes) {
          return;
        }
        //新規またはメールアドレス編集後登録時、認証メールの確認ダイアログを表示
        if (EditTypeUtility.getEditTypeInUrl() !== EditType.Readonly && isCaseVerification) {
          return service.dialogService
            .showYesOrNoConfirmDialog('このデータを登録すると\n発注先に認証メールが送信されます。\nよろしいですか。')
            .then((result) => {
              return ConfirmResult.Yes === result;
            });
        }
        return ConfirmResult.Yes === result;
      });
    };

    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    if (!checkInputParts(editPanel)) {
      return;
    }

    const registerRecord = editPanel.getIdAndValueAsObject();
    delete registerRecord['StatusName'];
    const request = Object.assign(editPanel.commonDBValue.getKeyValueForEditPanel(), registerRecord);
    const isCaseVerification =
      EditTypeUtility.getEditTypeInUrl() === EditType.New ||
      EditTypeUtility.getEditTypeInUrl() === EditType.Readonly ||
      request['EmailAddress'] !== this.initEmailAddress;

    if (isCaseVerification) {
      this.setVerifyToRecord(request);
    }

    showConfirmDialog().then((result) => {
      if (result) {
        displayLock('データ登録中');
        service.dataTransmissionService.registerRecord(ViewType.Edit, 'MSupplier', request, callBack, null, false);
      }
    });
  }

  /**
   * 削除ボタン押下時の処理
   * @param panelModels
   * @param service
   */
  deleteMSupplier(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const request = {
      [DbCommonColumnName.TICKET_TYPE]: editPanel.commonDBValue.ticketType,
      [DbCommonColumnName.TICKET_KEY]: editPanel.commonDBValue.ticketKey,
    };

    const callBackAfterDelete = () => {
      service.dialogService.showOkOnlyConfirmDialog('データを削除しました。').then(() => {
        this.moveToConditionList(service, editPanel);
      });
    };
    service.dataTransmissionService.deleteRecord(
      ViewType.Edit,
      editPanel.commonDBValue.ticketType,
      request,
      callBackAfterDelete
    );
  }

  /**
   * 発注先マスタの一覧画面に遷移する
   * @param service
   * @param editPanel
   */
  moveToConditionList(service: DevelopScriptServicePack, editPanel: EditPanelElementModel) {
    service.moveViewService.moveViewInGocooEngine(
      ViewType.ConditionList,
      editPanel.commonDBValue.ticketType,
      EditType.Readonly,
      {}
    );
  }
}
